import { render, staticRenderFns } from "./ListTask.vue?vue&type=template&id=32568f32&scoped=true"
import script from "./ListTask.vue?vue&type=script&lang=js"
export * from "./ListTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32568f32",
  null
  
)

export default component.exports